import CTAButton from "./CTAButton";

export default function UrgencySection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Stok Promo Hampir Habis";
  const desc = content.desc || "";
  const remaining = content.remaining || 27;
  const total = content.total || 100;
  const pct = (remaining / total) * 100;

  return (
    <section className="py-20 bg-background">
      <div className="mx-auto max-w-3xl px-5 text-center">
        <span className="inline-block rounded-full bg-red-50 text-red-600 px-4 py-1.5 text-xs font-bold uppercase tracking-widest">
          ⚠ Stok Hampir Habis
        </span>
        <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold">
          {title}
        </h2>
        {desc && (
          <p className="mt-4 text-muted-foreground">
            {desc}
          </p>
        )}

        <div className="mt-8 rounded-3xl bg-white border border-border p-6 shadow-card">
          <div className="flex justify-between text-sm font-semibold">
            <span className="text-primary">Tersisa {remaining} Paket</span>
            <span className="text-muted-foreground">dari {total}</span>
          </div>
          <div className="mt-3 h-4 rounded-full bg-secondary overflow-hidden">
            <div
              className="h-full bg-gradient-primary rounded-full transition-all"
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="mt-2 text-xs text-muted-foreground">Diperbarui hari ini</div>
        </div>

        <div className="mt-8">
          <CTAButton size="xl" pulse onClick={onCheckout} disabled={!canCheckout}>
            🛒 Checkout Sekarang
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
